import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Typography,
  Button,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import colors from "../../Constants/colors";
import { useWorkspaceColors } from "../../Contexts/WorkspaceColorContext";
import { ReleaseNote } from "../../Models/releaseNote";
import { formatDate } from "../../Helpers/dateHelpers";

interface ReleaseNoteDetailModalProps {
  open: boolean;
  onClose: () => void;
  note: ReleaseNote | null;
}

export function ReleaseNoteDetailModal({
  open,
  onClose,
  note,
}: ReleaseNoteDetailModalProps) {
  const { colors: workspace } = useWorkspaceColors();

  if (!note) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          pb: 2,
          borderRadius: 3,
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          pb: 2,
        }}
      >
        <Box>
          <Typography
            variant="h6"
            sx={{ fontWeight: 600, color: workspace.primary_dark }}
          >
            {note.title}
          </Typography>
          <Typography variant="caption" sx={{ color: colors.gray500 }}>
            {formatDate(note.created_at)}
          </Typography>
        </Box>
        <Button
          onClick={onClose}
          sx={{
            minWidth: "auto",
            p: 0.5,
            color: colors.gray500,
            "&:hover": {
              backgroundColor: colors.gray100,
            },
          }}
        >
          <Close />
        </Button>
      </DialogTitle>

      <DialogContent sx={{ px: 3, py: 2 }}>
        <Typography
          variant="body2"
          sx={{
            color: colors.gray700,
            whiteSpace: "pre-wrap",
            lineHeight: 1.6,
          }}
        >
          {note.description}
        </Typography>
      </DialogContent>
    </Dialog>
  );
}
